var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "currentBackgroundColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3441_6088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9634 9.8C13.9634 9.32261 14.1553 8.86477 14.4968 8.52721C14.8383 8.18964 15.3016 8 15.7846 8C16.2675 8 16.7308 8.18964 17.0723 8.52721C17.4138 8.86477 17.6057 9.32261 17.6057 9.8C18.6514 10.2887 19.5428 11.0495 20.1845 12.0008C20.8261 12.952 21.1937 14.058 21.248 15.2V17.9C21.3165 18.4595 21.517 18.9954 21.8333 19.4643C22.1496 19.9333 22.5729 20.3223 23.0691 20.6H8.5C8.9962 20.3223 9.4195 19.9333 9.73581 19.4643C10.0521 18.9954 10.2526 18.4595 10.3211 17.9V15.2C10.3754 14.058 10.743 12.952 11.3846 12.0008C12.0263 11.0495 12.9177 10.2887 13.9634 9.8Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 20.5996V21.4996C13.0527 22.2157 13.3405 22.9024 13.8528 23.4088C14.3651 23.9151 15.0599 24.1996 15.7844 24.1996C16.5089 24.1996 17.2038 23.9151 17.7161 23.4088C18.2283 22.9024 18.5161 22.2157 18.5161 21.4996V20.5996",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3441_6088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4cf055a72535adecb3d51a666409a2b3.svg";
export { ForwardRef as ReactComponent };